import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { isTranslationsOnlySession } from './translationOnlySession';

export const TranslationsOnlyRouteGuard = () => {
  const location = useLocation();

  if (location.pathname.startsWith('/editor')) return null;
  if (!isTranslationsOnlySession(location.search)) return null;

  return <Redirect to={{ pathname: '/editor', search: location.search }} />;
};
